<template>
  <div class="d-timetal">
    <div class="d-guides" v-if="!isReadOnly">
      <h4>Vejledning</h4>
      <p class="italic">
        I dette skema skal der indtastes oplysninger om de årlige undervisningstimer, som skolen planlægger at give
        eleverne i de enkelte fag på hver årgang. Bemærk, at timetallene skal opgøres som undervisningstimer á 60
        minutter.
        Der er automatisk importeret timetal fra UVM, som I har mulighed for at tilpasse. Hvis I ikke ønsker at bruge
        disse tal – eller ikke ønsker at indberette for en årgang – kan I blot klikke på "Nulstil".
        <br>
        <a class="text-link" target="_blank"
           href="https://test-data.stil.dk/grundskoleindberetning/Vejledninger/2024/1012/Praktisk%20vejledning_Antal%20elever%20og%20undervisningstimer_folkeskoler_2024.pdf">
          Læs den officielle vejledning fra STIL her
        </a>
        <p><b>Vær særlig opmærksom på:</b></p>
        <p>1) Tysk og Fransk skal udfyldes, da de står med 0.<br>2) Vælg hvilken årgang konfirmationsforberedelse finder
          sted.</p>
      </p>
    </div>
    <GrundskoleIndberetningTimetalFag
      class="marg-1-top"
      :undervisningskema="undervisningskema"
      :fagFraStil="fagFraStil"
      :isReadOnly="isReadOnly"
      @update="updateSubject"
      @updateKonfirmation="updateKonfirmation"
      @updatePraktik="updatePraktik"
      @setTolaerer="setTolaerer"
      @setForanstaltning="setForanstaltning"
      @nulstilKlasse="nulstilKlasse">
    </GrundskoleIndberetningTimetalFag>
    <GrundskoleIndberetningTimetalFagSpecial
      class="marg-1-top"
      :undervisningskema="undervisningskema"
      :isReadOnly="isReadOnly"
      @update="updateSubject"
      @updateKonfirmation="updateKonfirmation"
      @updatePraktik="updatePraktik"
      @setTolaerer="setTolaerer"
      @setForanstaltning="setForanstaltning">
    </GrundskoleIndberetningTimetalFagSpecial>
  </div>
</template>

<script>
import GrundskoleIndberetningTimetalFag from './GrundskoleIndberetningTimetalFag'
import GrundskoleIndberetningTimetalFagSpecial from './GrundskoleIndberetningTimetalFagSpecial'
import StilGuides from './StilGuides'

export default {
  components: {StilGuides, GrundskoleIndberetningTimetalFagSpecial, GrundskoleIndberetningTimetalFag},
  props: {
    stilData: {
      type: Object,
      default: () => {
      }
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      klasstype: {
        40: 'Normalklasse',
        50: 'Specialklasse'
      },
      grades: [
        {value: 1, title: '1.'},
        {value: 2, title: '2.'},
        {value: 3, title: '3.'},
        {value: 4, title: '4.'},
        {value: 5, title: '5.'},
        {value: 6, title: '6.'},
        {value: 7, title: '7.'},
        {value: 8, title: '8.'},
        {value: 9, title: '9.'}
      ],
      fag: {
        110: 'Dansk',
        120: 'Engelsk',
        130: 'Tysk',
        140: 'Fransk',
        170: 'Kristendomskundskab',
        171: 'Kristendomskundskab/religion (10. klasse)',
        181: 'Historie',
        182: 'Samfundsfag',
        210: 'Idræt',
        220: 'Musik',
        230: 'Billedkunst',
        902: 'Håndværk og design samt madkundskab',
        310: 'Matematik',
        320: 'Fysik/Kemi',
        330: 'Geografi',
        340: 'Biologi',
        350: 'Natur/teknologi',
        511: 'Praktisk/Musisk valgfag: Håndværk/design',
        520: 'Praktisk/Musisk valgfag: Musik',
        531: 'Praktisk/Musisk valgfag: Billedkunst',
        540: 'Praktisk/Musisk valgfag: Madkundskab',
        589: 'Andre tilbudsfag / valgfag',
        600: 'Børnehaveklasse',
        799: 'Øvrige fag',
        800: 'Understøttende undervisning'
      }
    }
  },
  computed: {
    undervisningskema () {
      return this.stilData && this.stilData['undervisningskema'] ? this.stilData['undervisningskema'] : []
    },
    fagFraStil () {
      const filteredKlassetrin = [0, '0', 10, '10']
      return this.stilData.undervisningskema.filter(type => type._type === 'undervisningstid' && type.klassetype === '40' && !filteredKlassetrin.includes(type.klassetrin))
    }
  },
  methods: {
    updateCell (type, cell, num) {
      const obj = {type, cell, num}
      this.$emit('update', obj)
    },
    updateSubject (obj) {
      this.$emit('updateSubject', obj)
    },
    updateKonfirmation (obj) {
      this.$emit('updateKonfirmation', obj)
    },
    updatePraktik (fag) {
      this.$emit('updatePraktik', fag)
    },
    setTolaerer (fag) {
      this.$emit('setTolaerer', fag)
    },
    setForanstaltning (foranstaltning) {
      this.$emit('setForanstaltning', foranstaltning)
    },
    nulstilKlasse (grade) {
      this.$emit('nulstilKlasse', grade)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.uppercase {
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  max-width: 1440px;
  min-width: 1100px;
  border-radius: 4px;
}

.d-table {
  width: 100%;
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table thead {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th,
.d-table tbody td {
  padding: 0.5rem 1rem;
  text-align: left;
  width: 75px !important;
}

.d-table thead tr th:first-child {
  border-radius: 4px 0 0 0;
}

.d-table tbody tr {
  width: 100%;
  background: #f9fafb;
  border-bottom: 1px solid #e3e8ee;
}

.d-table thead th {
  text-align: center;
}

input.d-input {
  outline: 0 !important;
  border: 1px solid #edf2f7;
  padding: 0.75rem 1rem;
  width: 100%;
  font-size: .85rem;
  margin: 0;
  -webkit-appearance: none !important;
  background-color: rgb(255, 255, 255);
  box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(64 68 82 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(64 68 82 / 8%) 0px 2px 5px 0px;
  box-sizing: border-box !important;
  transition: background-color .24s, box-shadow .24s;
  border-radius: 4px;
  text-align: center;
}

input.d-input:focus {
  border-color: var(--blue) !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
  -webkit-appearance: none !important;
}

.d-table thead tr th:first-child,
.d-table tbody tr td:first-child {
  width: 200px !important;
}

.d-table tbody tr:hover {
  background: aliceblue;
}

.d-guides {
  border: 1px solid rgba(204, 204, 204, 0.75);
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// GrundskoleIndberetningTimetal.vue?6a011238